<div *ngIf="isLoading$ | async" class="cssload-container">
    <div class="cssload-speeding-wheel"></div>
</div>